module.exports = __webpack_public_path__ + "07_long_gold.b1ea5ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_long_gold.png
// module id = 7vrE
// module chunks = 0